// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessageBody-module__link___RZQDw {
  color: inherit;
  text-decoration: underline;
  overflow-wrap: anywhere;
}`, "",{"version":3,"sources":["webpack://./src/components/elements/MessageBody/MessageBody.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,0BAAA;EACA,uBAAA;AACF","sourcesContent":[".link {\n  color: inherit;\n  text-decoration: underline;\n  overflow-wrap: anywhere;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `MessageBody-module__link___RZQDw`
};
module.exports = ___CSS_LOADER_EXPORT___;
